import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngstack/translate';
import { ILevelInfo } from 'src/app/interfaces/levelInfo';
import { IEducationPackage } from 'src/app/interfaces/educationPackage';
import { SurveyService } from 'src/app/services/http/business/survey/survey.service';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { ErrorsService } from 'src/app/services/common/errors.service';
import { StaticValueService } from 'src/app/services/http/business/staticValue/static-value.service';
import { IError } from 'src/app/interfaces/error.interface';

@Component({
  selector: 'app-sur-question-add',
  templateUrl: './sur-question-add.component.html',
  styleUrls: ['./sur-question-add.component.css']
})
export class SurQuestionAddComponent implements OnInit {

  param: any;
  errorList: IError[] = [];
  personInfo: any;
  errObject: any;
  form: FormGroup;
  errors = new Array();
  eduPackageList: IEducationPackage;
  levelInfoList: ILevelInfo;
  questionTypeList: any;

  constructor(
    private fb: FormBuilder,
    public translate: TranslateService,
    private staticValueService: StaticValueService,
    private errorService: ErrorsService,
    private snackBar: SnackBarService,
    private surService: SurveyService,
    public dialogRef: MatDialogRef<SurQuestionAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.createForm();
    this.getQuestionType();
  }

  createForm() {
    this.form = this.fb.group({
      Title: [null, Validators.required],
      QuestionCatId: [this.data.Id, Validators.required],
      QuestionTypeId: [null, Validators.required],
      AnswerDTOList: this.fb.array([])
    });

    const creds = this.form.controls.AnswerDTOList as FormArray;
    creds.push(
      this.fb.group({
        Title: new FormControl(null, Validators.required)
      })
    );

  }

  getQuestionType() {
    this.staticValueService.getQuestionType().subscribe(
      res => {
        this.questionTypeList = res;
      },
      () => {
      }
    );
  }

  addAnswer(): void {
    (<FormArray>this.form.get("AnswerDTOList")).push(
      new FormGroup({
        Title: new FormControl(null, Validators.compose([Validators.required]))
      })
    );
  }

  deleteAnswer(answerIndex: number) {
    (<FormArray>this.form.get("AnswerDTOList")).removeAt(answerIndex);
  }

  submit(data: any) {
    this.surService.surQuestionAdd(data).subscribe(
      () => {
        this.dialogRef.close(true);
        this.snackBar.OpenSnackBar(
          "ثبت با موفقیت انجام شد",
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
